import React, { useImperativeHandle, useEffect, useState } from 'react';
import { Alert, Form, Select, Spin } from 'antd';
import useBrands from '../../gql/hooks/useBrands';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';
import './styles.less';

const FormBrands = ( { form, modifiedCallback, ref, hideSeiko = false } ) => {
    const [ selectedBrands, setSelectedBrands ] = useState( [] );
    const [ showValidateAlert, setShowValidateAlert ] = useState( false );
    const { brands, brandsLoading, brandsError } = useBrands();
    const [ brandsVisible, setBrandsVisible ] = useState( true );
    const [ sync ] = useSyncObjectRelationships();

    useImperativeHandle( ref, () => ( {
        reset() {
            form.setFieldsValue( { brandIdsAreModified: false } ); 
            form.setFieldsValue( { brandIdsModified: [] } ); 
            setSelectedBrands( form.getFieldValue( 'brandIds' ) );
            setShowValidateAlert( false );
            modifiedCallback( false ); 
        },
        isModified() {
            return form.getFieldValue( 'brandIdsAreModified' );
        },
        validate() {
            return !brandsVisible ? true : validate();
        },
        async syncData() {
            const syncData = courseFormUtils.getBrandSyncValues( form );
            
            if ( syncData ) {
                try {
                    await sync( { variables: { input: syncData } } );
                    return true;
                } catch ( error ) { 
                    console.error( 'Error saving!', error );  
                    return false;
                } 
            }
        }
    } ) );
     
    const validate = () => {
        const brandIds = form.getFieldValue( 'brandIds' );
        const brandIdsAreModified = form.getFieldValue( 'brandIdsAreModified' );
        const brandIdsModified = form.getFieldValue( 'brandIdsModified' );

        if ( ( brandIdsAreModified && brandIdsModified.length < 1 ) || 
            ( !brandIdsAreModified && brandIds.length < 1 ) ) {
            setShowValidateAlert( true );
            return false;    
        } else {
            setShowValidateAlert( false );
            return true;
        }
    };

    useEffect( () => { 
        if ( brands ) {
            if ( brands.length === 1 ) {
                setBrandsVisible( false );
            }

            if ( !form.getFieldValue( 'id' ) && brands.length === 1 ) {
                form.setFieldsValue( { brandIdDefault: brands[ 0 ].id } ); 
            } 

            setSelectedBrands( form.getFieldValue( 'brandIds' ) );
        }
    }, [ brands, setSelectedBrands ] );

    const handleBrandChange = ( values ) => {
        setSelectedBrands( values ); 
    
        // check is modifed 
        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'brandIds' ) ) ) {
            form.setFieldsValue( { brandIdsAreModified: true } ); 
            form.setFieldsValue( { brandIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { brandIdsAreModified: false } ); 
            form.setFieldsValue( { brandIdsModified: [] } ); 
            modifiedCallback( false );
        }

        validate();
    };

    return (
        <div 
            id="brand-alert"
            className="form-item-brands"  
        >
            
            { brandsLoading && 
                <Spin />
            }
            
            { brandsError && 
                <Alert 
                    type="error"
                    message="Error"
                    description="An unknown error occurred. Please try again later."
                />
            }

            { !brandsLoading && !brandsError &&
                <div style= { brandsVisible ? {} : { display: 'none' } }>
                    { showValidateAlert &&
                        <Alert  
                            message="You must select a brand" 
                            type="error" 
                            style={ { marginBottom: '8px' } }
                        />
                    }

                    <Form.Item 
                        label="Brands"
                    >
                        <Select
                            mode="multiple"
                            className={ showValidateAlert ? 'failed-validation' : '' } 
                            value={ selectedBrands }
                            placeholder="Select Brands" 
                            onChange={ handleBrandChange }
                            filterOption={ ( input, option ) => 
                                ( option?.children ? 
                                    option.children[ 0 ].type ? '' : option.children[ 0 ]
                                    : '' ).toLowerCase().includes( input.toLowerCase() )
                            }
                        >
                            {
                                brands.map( i => {
                                    if ( hideSeiko ) {
                                        if ( i.name === 'Seiko' ) {
                                            return;
                                        }
                                    }

                                    return ( 
                                        <Select.Option 
                                            key={ i.id } 
                                            value={ i.id }  
                                        >
                                            { i.name || <span className='italic'>No Name</span> }
                                        </Select.Option>
                                    );
                                } )
                            }
                        </Select>
                    </Form.Item>
                </div>
            }
        </div>
    );
};

export default FormBrands;
